

<template>
  <div class="modal media-preview-modal" ref="mediaPreviewModal" tabindex="-1" role="dialog" style="z-index:99999999;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
    <div class="modal-header p-2" style="height:64px">
            <div class="titile-area">
                <h6 class="modal-title">{{selectedFile.slug_name}}</h6>
            </div>
            <div class="action-button" :style="[ !isMinimizeIconRequired() && !isMininimizeIconReqrd ? {width: 'unset !important'}: '']">
                 <button type="button" v-show="isMinimizeIconRequired() && isMininimizeIconReqrd" style="margin-top: 0 !important;" class="close text-white" data-dismiss="modal" aria-label="Close" @click="maximisePlayer()">
                    <span aria-hidden="true">
                      <svg width="1.5em" height="0.95em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-box-arrow-down-right"><path  fill-rule="evenodd" d="M8.636 12.5a.5.5 0 0 1-.5.5H1.5A1.5 1.5 0 0 1 0 11.5v-10A1.5 1.5 0 0 1 1.5 0h10A1.5 1.5 0 0 1 13 1.5v6.636a.5.5 0 0 1-1 0V1.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6.636a.5.5 0 0 1 .5.5z"></path><path  fill-rule="evenodd" d="M16 15.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h3.793L6.146 6.854a.5.5 0 1 1 .708-.708L15 14.293V10.5a.5.5 0 0 1 1 0v5z"></path></svg>
                    </span>
                 </button>
                <button type="button" style="margin-top: 0 !important;" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModel()">  
                    <span aria-hidden="true">
                        <CancelIcon class="close-icon" style="height: 40px !important;width: 40px !important;color: #fff;"/>
                    </span>
                </button>
            </div>
      </div>
      <div class="modal-body">
            <div v-viewer v-if="getFileMimeType(selectedFile) == 'image'" class="image-preview" style="max-width:100%;max-height:calc(100vh - 65px);background: #000;">
                <img style="max-width: 100%;max-height: 100%;" :src="getThumbnailInfo()" @error="replaceByDefaultImage"/>
            </div>
            <div class="document-preview" v-if="isSupportedDocumentType" style="width:100vw;height:100vh;">
                <iframe ref="iframeRef" style="width:100%;height:100%;" :src="getDocFilePath()">
                </iframe>
            </div>
            <div class="3d-models-preview" v-if="is3dModelType()" style="width:100vw;height:100vh;">
                 <span v-html="modelViewer"></span>
            </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@google/model-viewer/dist/model-viewer.js';
import CancelIcon from "../core/InlineCancelField.vue";
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import Utils from '../../components.utils';
import Constants from '../../components.constants';
Vue.use(VueViewer);
VueViewer.setDefaults({
      button:false,
      title:false,
      zoomOnTouch:false,
      slideOnTouch:false,
      navbar:false,
      toolbar:{
          zoomIn: 1,
          zoomOut:3,
          reset:2,
      },
     options:{
         show:true,
     }
  })
export default {
   name:'ImagePreviewDialog',
   props:['selectedFile','isDialgMinimizeIconRequired'],
   components:{
       CancelIcon
   },
   data(){
       return {
           imagePreviewObj :{width:null,height:null},
           imageUrl:'',
           docPreviewList: Constants.supportedDocumentPreviewList,
           d3dfilePreviewList:Constants.supported3dModelPreviewList,
           modelViewer: '',
           isMininimizeIconReqrd: true
       }
   },
   methods:{
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        getDocFilePath(){
            let src = Utils.getPDFPATHFromFileInfo(this.selectedFile);
            if(!src) { 
                setTimeout(()=>{
                    this.$refs.iframeRef.contentWindow.document.body.querySelector('img').style.cssText += `margin: auto; height: 100%;`
                },400);
                setTimeout(()=>{
                    this.$refs.iframeRef.contentWindow.document.body.querySelector('img').style.cssText += `margin: auto; height: 100%;`
                },1200);
                return Utils.getNoThumbnailImg();
            }
            return src;
        },
        getFileMimeType(fileObj){
            let supportedMimeType = ['audio','video','image','other'];
            for(let i = 0; i < supportedMimeType.length; i++){
                if(String(fileObj.mime_type).toLowerCase().startsWith(supportedMimeType[i])) return supportedMimeType[i];
            }
            return 'other';
        },
      
       getPreviewType(){
           return this.getFileMimeType(this.selectedFile);
       },
       imageNotFound(){
           console.error('Image not found');
       },
       closeModel(){
          this.$emit("closeMiniPlayer");
       },
       maximisePlayer(){
            this.$emit("maximisePlayer");
       },
       reRenderImage(){
            this.imageUrl = Utils.getThumbnailPathfromFileInfo(this.selectedFile);
       },
       get3dModelPath(){
           return String(Constants.extendedUrl + '/file/'+ this.selectedFile._id);
      },
      is3dModel(){
          let filename = this.selectedFile.file_name;
          return this.d3dfilePreviewList.indexOf(filename.substring(filename.lastIndexOf('.')+1, filename.length) || filename) > -1; 
      },
      is3dModelType(){
           let res = this.is3dModel();
           if(res) this.modelViewer = `<model-viewer style="width:100%;height:92%;background:#000; --progress-bar-color:#2196f3; " src=${this.get3dModelPath()}  alt="A 3D model of ${this.selectedFile.file_name}" shadow-intensity="1" camera-controls="true" auto-rotate="true" ar="true"></model-viewer>`;
          return res;
      },
     isMinimizeIconRequired(){
        return  !(this.is3dModel() || this.isSupportedDocumentType);
     },
     handlePreviewKeyboard(event){
          let keyCode = event.keyCode || event.which;
          if(keyCode == 27){ // ESC key
              this.closeModel();
              return true;
          }
     },
     getThumbnailInfo(){
         return Utils.getThumbnailPathfromFileInfo(this.selectedFile);
     }
   },
   created(){
      if(this.isDialgMinimizeIconRequired != null){
          this.isMininimizeIconReqrd = this.isDialgMinimizeIconRequired;
       }
    },
    mounted(){
        window.addEventListener('keydown', this.handlePreviewKeyboard);
    },
   computed:{
      isSupportedDocumentType(){
          return this.docPreviewList.indexOf(Utils.getFileMediaType(this.selectedFile)) > -1;
      },
   },
   beforeDestroy(){
      window.removeEventListener('keydown', this.handlePreviewKeyboard);
   }
}
</script>

<style lang="scss" scoped>

$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;


.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }

 .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      overflow:hidden;
      padding: 0px 0px 0px 0px;
    //   display:inline-flex;
      width:100%;
      position:relative;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}

.modal-body{
    padding: 0 !important;
    width: 100%;
    background: $secondary-background-color !important;
}

.image-preview{
    margin: auto;
    width: 100%;
    height: calc(-65px + 100vh);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
    //   color:$header-color;
      padding:3px;
    }
}

.modal-header .close {
    margin: -1rem -19px -0rem auto !important;
}

.modal-header{
    border: $secondary-border-color;
    background: $secondary-background-color;
    height:35px;
    display:flex;
    align-items:center;
    justify-content: space-between;
}

.modal-footer{
    justify-content: start;
    position: fixed;
    inset-inline-start: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index:9;
}

.action-button{
    // width: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.action-button .close-icon:hover{
    border-radius: 20px;
    /* background: #1e1d1d; */
    background: $icon-hover;
    filter: brightness(111%);
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>